import { render } from "./DetailPartnerPage.vue?vue&type=template&id=15359760&scoped=true"
import script from "./DetailPartnerPage.vue?vue&type=script&lang=js"
export * from "./DetailPartnerPage.vue?vue&type=script&lang=js"

import "./DetailPartnerPage.vue?vue&type=style&index=0&id=15359760&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15359760"]])

export default __exports__